<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-content">
      <button class="modal-close" @click="cancelar">×</button>
      <img src="@/assets/apps/alerta.png" class="max-w-xs mx-auto mb-4" />
      <h3 class="text-xl font-bold mb-2">{{ titulo }}</h3>
      <p class="text-base text-center mb-4">{{ mensagem }}</p>
      <div class="modal-actions">
        <button class="btn-confirm" @click="confirmar">
          {{ textoConfirmar }}
        </button>
        <button class="btn-cancel" @click="cancelar" v-if="textoCancelar">
          {{ textoCancelar }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    visible: Boolean,
    titulo: {
      type: String,
      default: 'Confirmação'
    },
    mensagem: {
      type: String,
      default: 'Tem certeza que deseja continuar?'
    },
    textoConfirmar: {
      type: String,
      default: 'Confirmar'
    },
    textoCancelar: {
      type: String,
    }
  },
  methods: {
    confirmar() {
      this.$emit('confirmar')
    },
    cancelar() {
      this.$emit('cancelar')
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  width: 90%;
  max-width: 400px;
  position: relative;
}

.modal-close {
  position: absolute;
  top: 5px;
  right: 10px;
  border: none;
  background: transparent;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.modal-actions {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}

.btn-confirm {
  background-color: #673bb7;
  color: white;
  padding: 10px 20px;
  border-radius: 6px;
}

.btn-cancel {
  background-color: #ccc;
  color: black;
  padding: 10px 20px;
  border-radius: 6px;
}
</style>
